import axios from "axios";

const LavoriStore={
    state:()=>({
        lavori:[],
        loaded:false
    }),
    mutations:{
        lavoriCaricati(state, item){
            state.lavori=[...item];
            state.loaded=true;
            return [...item];
        },
        // tasksCreated(state, item){
        //     if(item.tsCreato.idTicketParent>0){
        //         let lavoroTS=state.lavori.filter(att=>att.id_ticket===item.tsCreato.idTicketParent);
        //         if(lavoroTS.length>0){
        //             item.tsCreato.titoloLavoro=lavoroTS[0]?.titolo;
        //         }
        //     }
        //     this.commit("taskLoadedPM", [...item.tuttiTS])
        //     this.commit("tasksLoaded", [...item.tuttiTS])
        // }
    },
    actions: {
        async loadLavori({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                //commit("showMiniLoader");
                commit('addRequest')
                commit("showMiniLoader");
                let startLoading=new Date().getTime();
                console.log("start loading getLavori");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getLavori", {}, {...config}).then(response=>{
                    commit('removeRequest')
                    commit("hideMiniLoader");
                    if(response.data.responseCode!==200){
                        throw new Error(response.data.dettagli)
                    }
                    console.log("finished loading getLavori in ",(new Date().getTime()-startLoading)," ms");
                    let result=null;
                    if(response.data.resultObj){
                        console.log("using directly resultObj")
                        result=response.data.resultObj;
                    }else{
                        result=JSON.parse(response.data.result);
                        console.log("finished loading getLavori parsing json ",(new Date().getTime()-startLoading)," ms");
                    }
                    //commit("hideMiniLoader");
                    commit('removeRequest')
                    commit("hideMiniLoader");
                    commit("lavoriCaricati", result);
                }).catch(ex=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    commit('addMessage', {
                        message:"VUEX loadLavori error: "+ex.message,
                        messageType:'error'
                    });
                });
                //let response= await request;

            }catch(e){
                commit('removeRequest');
                commit("hideMiniLoader");
                commit('addMessage', {
                    message:"VUEX loadLavori error: "+e.message,
                    messageType:'error'
                });
            }
        },
    },
    getters:{
        getLavori: (state) => (status) => {
            if(!state.loaded){
                return false
            }
            return [...state.lavori]
        },

        getLavoroTicket: (state) => (idTicket) => {
            if(!state.loaded){
                return false
            }
            return [...state.lavori.filter(lav=>lav.id_ticket===idTicket)]
        }
    }
}

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

export {LavoriStore};